// @flow

import axios from 'axios';
import { getBaseUrl } from '../config/config';

export default function getMilestoneDetail(projectId: string, milestoneId: number, delayId: number): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/criticalmilestones/${milestoneId}/changehistory/${delayId}`);
}
